// extracted by mini-css-extract-plugin
module.exports = {"newsletter_widget":"NewsletterWidget_newsletter_widget__T4m41","title":"NewsletterWidget_title__j0gem","button":"NewsletterWidget_button__yBMwu"};